module.exports = __webpack_public_path__ + "img/mail.61bd857b.svg";